var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 22.5v-5h10v5H40zM43 40l-8-6 3-4 8 6-3 4zm-5-30-3-4 8-6 3 4-8 6zM7.5 37.5v-10H5c-1.375 0-2.552-.49-3.53-1.468C.492 25.054.002 23.877 0 22.5v-5c0-1.375.49-2.552 1.47-3.53.98-.978 2.157-1.468 3.53-1.47h10L27.5 5v30L15 27.5h-2.5v10h-5zM30 28.375v-16.75c1.125 1 2.032 2.22 2.72 3.658.688 1.438 1.032 3.01 1.03 4.717-.002 1.707-.346 3.28-1.032 4.72-.687 1.44-1.593 2.658-2.718 3.655z",
    fill: "#075985"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/Campaign.0e445f5947037fc8bcaafffa0b113f88.svg";
export { ForwardRef as ReactComponent };